// Types & schémas d'auth — reflètent §6bis du contrat gelé
// `CONTRACT-AUTHENTIFICATION.md` (racine du repo). Ne JAMAIS ajouter de champ
// ici qui ne soit pas dans le contrat : le schéma zod fait aussi office de
// garde-fou (une réponse API qui renverrait un hash ou un jeton par erreur
// ferait échouer la validation plutôt que de le laisser fuiter côté client).

import { z } from 'zod';

// `service` = compte technique de dépôt SharePoint (API, migration 039).
export const RoleSchema = z.enum(['admin', 'utilisateur', 'service']);
export type Role = z.infer<typeof RoleSchema>;

export const UtilisateurSchema = z.object({
  id: z.number(),
  email: z.string(),
  nom: z.string(),
  role: RoleSchema,
  estSuperAdmin: z.boolean(),
  actif: z.boolean(),
  derniereConnexionAt: z.string().nullable(),
});
export type Utilisateur = z.infer<typeof UtilisateurSchema>;

export const MoiResponseSchema = z.object({ utilisateur: UtilisateurSchema });
export const LoginResponseSchema = z.object({ utilisateur: UtilisateurSchema });
